import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { stripCardDriverFactory } from './StripCard.driver';
import { StripCard } from '.';

describe('StripCard', () => {
  const createDriver = createRendererWithUniDriver(stripCardDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<StripCard />);
    expect(await driver.exists()).toBe(true);
  });

  it('should render info', async () => {
    const textContent = 'info!';
    const value = <div>{textContent}</div>;
    const { driver } = createDriver(<StripCard info={value} />);
    expect((await driver.getInfoContent()).innerHTML).toEqual(textContent);
  });

  it('should render image', async () => {
    const textContent = 'image!';
    const value = <div>{textContent}</div>;
    const { driver } = createDriver(<StripCard media={value} />);
    expect((await driver.getMediaContent()).innerHTML).toEqual(textContent);
  });

  it('should render round media', async () => {
    const { driver } = createDriver(
      <StripCard roundMedia media={<div>image</div>} />,
    );
    expect(await driver.isMediaRounded()).toEqual(true);
  });

  it('should render without side padding', async () => {
    const { driver } = createDriver(<StripCard sidePadding={false} />);
    expect(await driver.isWithSidePadding()).toEqual(false);
  });
});
